import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async'
import Spinner from '../../util/spinner-shim'
import { useParams, useNavigate, useLocation } from 'react-router-dom'

import { injectIntl } from 'react-intl'
import AppDispatcher from '../../dispatchers/AppDispatcher'
import withAppStore from '../../util/withAppStore'

// components
import NavigationBar from '../partials/NavigationBar'
import Footer from '../partials/Footer'
import GridList from '../partials/GridList'

import styles from '../../../css/devicePage.module.css'

function ReplaceModemPage (props) {
  const { customerID } = useParams()
  const navigate = useNavigate()
  const location = useLocation()

  const [state, setState] = React.useState({
    deviceType: '',
  })

  // Extract query parameters from location
  const searchParams = new URLSearchParams(location.search)
  const deviceGroup = searchParams.get('deviceGroup') || null
  const groupID = searchParams.get('groupID') || null
  const isActive = searchParams.get('isActive')
  const deviceGroupName = searchParams.get('deviceGroupName') || null

  const dispatch = React.useCallback((action) => AppDispatcher.dispatch({ action }), [])

  const getNewData = React.useCallback(() => {
    const action = {
      action: 'get-devices',
      deviceGroup,
      customerID,
      groupID,
      // only show inactive devices when explicitly requested (Settings > Inactive Devices)
      isActive: isActive || 'true',
    }
    AppDispatcher.dispatch(action)
  }, [deviceGroup, customerID, groupID, isActive])

  const routeTo = React.useCallback((destination) => {
    navigate(`/${customerID}/settings/${destination}`)
  }, [customerID, navigate])

  const backToHome = React.useCallback(() => {
    dispatch('unload-group-devices')

    if (isActive === 'false' && !groupID) {
      navigate('/settings')
      return
    }
    navigate('/')
  }, [dispatch, isActive, groupID, navigate])

  React.useEffect(() => {
    dispatch('unload-metric')
    dispatch('unload-device-status')
    const interval = setInterval(getNewData, props.data?.pollInterval || 5000)

    AppDispatcher.dispatch({
      action: 'save-history-list',
      path: `${location.pathname}${location.search}`,
    })

    return () => clearInterval(interval)
  }, [dispatch, getNewData, props.data?.pollInterval, location.pathname, location.search])

  React.useEffect(() => {
    getNewData()
  }, [getNewData])

  const render = () => {
    const {
      auth: { logout },
      data,
      pages: { DeviceList: title },
      route: { path: page },
    } = props

    const deviceData = data.groupDevices
    const { ready, devices } = deviceData || {}
    const {
      deviceType,
    } = state

    let currentDevices = []

    if (deviceData && ready && Array.isArray(devices)) {
      devices.forEach((device) => {
        if (device.interface_versioned) {
          if (device.interface_versioned.type === deviceType) {
            currentDevices.push(device)
          }
        }
      })
      if (currentDevices.length === 0) {
        currentDevices = devices
      }
    }

    const cleanDevices = currentDevices.filter((x) => x.configuration.simIccid !== undefined)
    currentDevices = cleanDevices.filter((x) => x.physical.cellularAccessTechnologyDetail === '' ||
      x.physical.cellularAccessTechnologyDetail === 'UMTS' ||
      x.physical.cellularAccessTechnologyDetail === 'RXLEV' ||
      x.configuration.simIccid.match(/8934.*/) ||
      x.configuration.simIccid.match(/8944.*/))

    const gridList =
      deviceData && ready && Array.isArray(currentDevices)
        ? (
          <GridList
            devices={currentDevices}
            deviceType={deviceType}
            sort={data?.sort}
            tileInfo='default'
          />
          )
        : (
          <div className='loading'>
            <Spinner name='double-bounce' />
          </div>
          )

    return (
      <div className={styles.pageBottom}>
        <Helmet><title>{title}</title></Helmet>
        <NavigationBar
          backFunc={backToHome}
          logOut={() => logout(navigate)}
          name='Replace Modems'
          page={page}
          subMenuClose={() => {}}
        />
        {gridList}
        <Footer />
      </div>
    )
  }

  return render()
}

ReplaceModemPage.propTypes = {
  auth: PropTypes.object,
  data: PropTypes.object,
  pages: PropTypes.object,
  route: PropTypes.object,
}

export default withAppStore(injectIntl(ReplaceModemPage))
